<app-dashboard-admin style="width: inherit;"></app-dashboard-admin>
<section style="background: #f1f1f1; padding-bottom: 4%;">
  <div class="row">
    <div class="col-sm" style="height: 10px;"></div>
    <div class="col-md" style="height: 20px"></div>
  </div>

  <div class="container-fluid">
    <div class="row">
      <div class="col-md-12">
        <nav aria-label="breadcrumb" class="bread-styles">
          <ol class="breadcrumb bd-background">
            <li class="breadcrumb-item active" aria-current="page">
                <a routerLink="dashboardmain-admin"><i class="fa fa-home" aria-hidden="true"></i></a> &nbsp;
              <a href="dashboardmain-admin">Dashboard</a>
            </li>
          </ol>
        </nav>
      </div>
    </div>

    <div class="row">
      <div class="col-sm" style="height: 10px;"></div>
      <div class="col-md" style="height: 20px"></div>
    </div>

    <div class="pie-charts">
      <div class="row">
        <div class="col-md-6 m-t-mobile">
          <div class="card">
            <div class="card-header">Total Users</div>
            <div class="card-body">
              <!-- <p class="card-text">Some quick example text to build on the card title and make up the bulk of the card's
                content.</p> -->
                <div class="chart-wrapper">
                  <canvas baseChart 
                  [data]="doughnutChartData"
                  [labels]="doughnutChartLabels"
                  [chartType]="doughnutChartType">
                </canvas>
              </div> 
            </div>
          </div>
        </div>
        <div class="col-md-6">
          <div class="card">
            <div class="card-header">Total Categories</div>
            <div class="card-body">
              <div class="chart-wrapper">
                <canvas baseChart 
                [data]="pieChartData" 
                [labels]="pieChartLabels" 
                [chartType]="pieChartType"
                [options]="pieChartOptions"
                [plugins]="pieChartPlugins"
                [legend]="pieChartLegend">
              </canvas>
            </div>
            </div>
          </div>
        </div>
      </div>
      <hr>
      <div class="row">
        <div class="col-md-6">
          <div class="card">
            <div class="card-header">User Tax Files</div>
            <div class="card-body">
              <div class="chart-wrapper">
                <canvas baseChart 
                [datasets]="barChartData"
                [labels]="barChartLabels"
                [options]="barChartOptions"
                [plugins]="barChartPlugins"
                [legend]="barChartLegend"
                [chartType]="barChartType"
                [colors]="lineChartColors">
              </canvas>
            </div>
            </div>
          </div>
        </div>
        <div class="col-md-6">
        </div>
      </div>
    </div>
  </div>
</section>